export const formatDateWithSuffix = (dateString: any, locale: string) => {
	const todayDate = new Date()
	const dateObj = new Date(dateString)
	const day = dateObj.getDate()
	const month = dateObj.toLocaleString(locale, { month: 'long' })
	const year = dateObj.getFullYear()

	//Current month = x + 6 = this will always get to validate the current year and 6 months before
	const currentMonth = todayDate.getMonth() + 6
	const targetDate = new Date(todayDate)
	targetDate.setMonth(todayDate.getMonth() - currentMonth)

	if (dateObj < targetDate) {
		return ''
	}
	const suffix =
		day === 1 || day === 21 || day === 31
			? 'st'
			: day === 2 || day === 22
			? 'nd'
			: day === 3 || day === 23
			? 'rd'
			: 'th'

	return `${month} ${day}${suffix}, ${year}`
}
